import React, {useEffect, useState} from "react";
import "./AchievementsListCard.css";
import {Modal} from "react-bootstrap";
import ModalClose from "../../assets/modal_close.png";
import TextEditorContent from "../TextEditorContent";
import {FaLinkedinIn} from "react-icons/fa";
import {toast} from "react-toastify";
import {userService} from "../../services/usersService/userService";
import {useNavigate, useParams} from "react-router-dom";
import {useQuery} from "../../hooks/useQuery";

const AchievementsListCard = ({ title = 'Achievements', achievements, unopenedBadges = [], withViewAll = false }) => {

    const navigate = useNavigate();
    const [selectedAchievement, setSelectedAchievement] = useState(null);
    const query = useQuery();
    const badgeId = query.get('badgeId');

    useEffect(() => {
        if (badgeId) {
            const badgePreview = achievements.find(badge => badge.id == badgeId);
            setSelectedAchievement(badgePreview);
        }
    }, [badgeId]);

    const closeSelectedAchievementModal = () => {
        setSelectedAchievement(null);
    };

    const handleSelectAchievement = (achievement) => {
        setSelectedAchievement(achievement);
    };

    const shareOnLinkedin = async (badgeId) => {
        try {
            const { data } = await userService.shareBadgeOnLinkedin(badgeId);
            window.open(data.share_url, '_blank');
        } catch (err) {
            toast.error(err.response?.data?.message || 'Failed to share');
        }
    };

    return (
        <>
            <div className="user-profile-achievements p-3">
                <div className="d-flex justify-content-between">
                    <h5>{title}</h5>
                    {withViewAll &&
                        <button className="btn btn-primary-info" onClick={() => navigate("/profile-settings/achievements")}>View All</button>
                    }
                </div>
                <div className="d-flex justify-content-start flex-wrap my-4">
                    {achievements.map((achievement) => {
                        return <div className="text-center user-profile-achievements__item cursor-pointer" key={achievement.id} onClick={() => handleSelectAchievement(achievement)}>
                            <img className="user-profile-achievements__item__logo" src={achievement.logo}/>
                            <div>{achievement.name}</div>
                        </div>
                    })}
                    {unopenedBadges.map((achievement) => {
                        return <div className="text-center user-profile-achievements__item cursor-pointer badge-locked" key={achievement.id} onClick={() => handleSelectAchievement(achievement)}>
                            <img className="user-profile-achievements__item__logo" src={achievement.logo}/>
                            <div>{achievement.name}</div>
                        </div>
                    })}
                </div>
            </div>
            {selectedAchievement &&
                <Modal onHide={closeSelectedAchievementModal} centered show="true" size="lg" aria-labelledby="contained-modal-title-vcenter">
                    <Modal.Header className="modal-header m-0">
                        <div className="question">{selectedAchievement.name}</div>
                        <div className="modal-close" onClick={() => closeSelectedAchievementModal()}>
                            <img src={ModalClose} alt="Close" />
                        </div>
                    </Modal.Header>
                    <Modal.Body
                        style={{maxHeight: "450px", overflowY: "scroll"}}
                    >
                        <div className="row mt-3 px-3">
                            <TextEditorContent
                                text={selectedAchievement.description}
                            />
                        </div>
                    </Modal.Body>
                    {selectedAchievement.is_shareable &&
                        <Modal.Footer>
                            <div className="d-flex">
                                <div className="mr-30">
                                    <img className="user-profile-achievements__item__logo" src={selectedAchievement.logo}/>
                                </div>
                                <div>
                                    <div className="fs-6 lh-base fw-bolder mr-5">
                                        Share your badge on social media:
                                    </div>
                                    <div className="d-flex justify-content-start flex-wrap my-2">
                                        <div className="share-certificate-icon share-badge__linkedin cursor-pointer d-flex align-center" onClick={() => shareOnLinkedin(selectedAchievement.id)}>
                                            <FaLinkedinIn
                                                className={`fs-6 mr-5`}
                                            />
                                            <div className="fs-6 lh-base">
                                                Linkedin
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal.Footer>
                    }
                </Modal>
            }
        </>
    );
};

export default AchievementsListCard;